// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { getParagraphStyleById } from 'app/constants/enums/ParagraphStyle/main';

/* eslint-disable max-len */
export const EXPRESSIONS = getParagraphStyleById('Expressions');
export const ORDERED_LIST = getParagraphStyleById('OrderedList');
export const PLAIN = getParagraphStyleById('Plain');
export const POEM = getParagraphStyleById('Poem');
export const TIP = getParagraphStyleById('Tip');
export const UNORDERED_LIST = getParagraphStyleById('UnorderedList');
/* eslint-enable max-len */
